export const mapOrderName = (status: string) => {
  const map: Record<string, string> = {
    ready_to_ship: 'readyToShip',
    ready_for_pickup: 'readyForPickup',
  };

  return map[status] ?? status;
};
